import { render, staticRenderFns } from "./ComponentGlobalTypeDropdown.vue?vue&type=template&id=1d61b76f&"
import script from "./ComponentGlobalTypeDropdown.vue?vue&type=script&lang=js&"
export * from "./ComponentGlobalTypeDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ComponentGlobalTypeDropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports